import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download } from "react-feather";
import { Dropdown, Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl } from "../../Baseurl";

const AllListingCost = () => {
  const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCost, setTotalCost] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllSellerListingsadmin`);
        if (response.data.success) {
          const data = response.data.data;

          setListings(data);
          setFilteredData(data);

          const cost = data.reduce((acc, item) => {
            const qty = item.quantity || 0;
            const price = parseFloat(item.price) || 0;
            return acc + qty * price;
          }, 0);
          setTotalCost(cost);
        }
      } catch (error) {
        console.error("Error fetching listings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = listings.filter((listing) =>
      listing.title.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Seller Listings");
    XLSX.writeFile(wb, "all_seller_listings.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Total Listings Price Available In Stock</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Listings"
                value={searchTerm}
                onChange={handleSearch}
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(listings)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <span className="btn btn-success" onClick={handleDownloadExcel}>
                <Download size={17} />&nbsp;Download
              </span>
            </div>
          </div>

          {/* Total Cost Summary Card */}
          <div className="card mb-3">
            <div className="card-body d-flex justify-content-start align-items-center">
              <h5 className="mb-0">Total Inventory Cost: &nbsp;</h5>
              <h4 className="ag2 font4 text-danger mb-0">
                ₹
                {totalCost.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </h4>
            </div>
          </div>

          <div className="card">
            <div className="card-body table-responsive">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}
                >
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <table className="custom-table">
                  <thead className=" ">
                    <tr>
                      <th>#</th>
                      <th>Listing ID</th>
                      <th>Title</th>
                      <th>Condition</th>
                      <th>Type</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Total Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => {
                        const qty = row.quantity || 1;
                        const price = parseFloat(row.price) || 0;
                        const total = qty * price;
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{row.listing_unique_id}</td>
                            <td>{row.title}</td>
                            <td>{row.condition}</td>
                            <td>{row.type}</td>
                            <td>₹{price.toFixed(2)}</td>
                            <td>{qty}</td>
                            <td>₹{total.toFixed(2)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No listings found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllListingCost;
